<div id="loader" class="loader">
  <div class="loader-content">
    <img width="200" src="assets/images/loader/confe-loader3.gif" />
    <!-- <p id="loader-text">Switching workspace...</p>
    <p-progressSpinner></p-progressSpinner>-->
  </div>
</div>
